var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"u-fixed u-pos-tl u-index-10 u-marg-t-md u-marg-t-xs@sm u-fit-w"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }